var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"pay-qr-danmaku",attrs:{"aria-hidden":"true"}},_vm._l((_vm.items),function(item){return _c('span',{key:item.id,staticClass:"pay-qr-danmaku__item",style:(item.style)},[_vm._v(_vm._s(_vm.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }